import React from 'react';

import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import InputControl from './InputControl';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import { InputType } from 'src/presentation/components/forms/InputField';

enum RelativeTimePeriod {
  daysAgo = 'daysAgo',
  bizDaysAgo = 'bizDaysAgo',
  hoursAgo = 'hoursAgo',
  minutesAgo = 'minutesAgo',
}

const relativeTimePeriodOptions = [
  { label: 'Days Ago', value: RelativeTimePeriod.daysAgo },
  { label: 'Business Days Ago', value: RelativeTimePeriod.bizDaysAgo },
  { label: 'Hours Ago', value: RelativeTimePeriod.hoursAgo },
  { label: 'Minutes Ago', value: RelativeTimePeriod.minutesAgo },
];

export interface RelativeTime {
  num: number;
  period: RelativeTimePeriod;
}

const RelativeTimeControl = ({
  'data-aid': dataAid,
  attr,
  disabled,
  typeSpec,
}: {
  'data-aid'?: string;
  attr: string;
  disabled: boolean;
  typeSpec: TypeSpec;
}) => {
  return (
    <>
      <InputControl
        attr={`${attr}.num`}
        data-aid={`${dataAid}-num`}
        disabled={disabled}
        type={InputType.number}
        typeSpec={typeSpec}
      />
      <Dropdown
        attr={`${attr}.period`}
        data-aid={`${dataAid}-period`}
        disabled={disabled}
        options={relativeTimePeriodOptions}
        typeSpec={typeSpec}
      />
    </>
  );
};

export default RelativeTimeControl;
